<template>
  <div>
    <section
      class="travel-list-box"
      v-if="
        CategoryData.Category != null && CategoryData.Category.Type == 0
          ? true
          : false
      "
    >
      <div class="container">
        <div class="box">
          <div class="title-box">
            <h1>{{ CategoryData.Category.CategoryName }}</h1>
            <hr />
          </div>
          <ul class="list-box">
            <li v-for="Post in Posts" :key="Post.PId" class="list-box">
              <a href="javascript:void(0);" @click="gotoPost(Post)">
                <p class="time">
                  {{ Post.PublicStartTime | timeString("YYYY-MM-DD") }}
                </p>
                <p>
                  {{ Post.Title }}
                </p>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="page" v-if="pageAll > 1">
        <div class="container">
          <paginate
            :no-li-surround="false"
            :page-count="pageAll"
            :page-range="3"
            :margin-pages="1"
            :click-handler="loadList"
            :prev-text="'<'"
            :next-text="'>'"
            :prev-link-class="'Prev'"
            :next-link-class="'next'"
            :container-class="''"
            :page-link-class="''"
            :active-class="'page-active'"
            :hide-prev-next="false"
          >
          </paginate>
        </div>
      </div>
    </section>
    <section
      class="member-box"
      v-if="
        CategoryData.Category != null && CategoryData.Category.Type == 2
          ? true
          : false
      "
    >
      <div class="container">
        <div
          class="btn-box"
          v-if="
            CategoryData.Category.Type == 2 &&
            CategoryData.SubCategorys != null &&
            CategoryData.SubCategorys.length > 0
          "
        >
          <button
            v-for="SubCategory in CategoryData.SubCategorys"
            :key="SubCategory.CId"
            @click="changeCategory(SubCategory.CId)"
            :class="active == SubCategory.CId ? 'active' : ''"
            tag="button"
          >
            {{ SubCategory.CategoryName }}
          </button>
        </div>
        <div class="main-box">
          <div class="main show">
            <ul class="qa show">
              <li
                class="box"
                v-for="Post in Posts"
                :key="Post.PId"
                style="cursor: pointer"
              >
                <h2><span>Q</span> {{ Post.Title }}</h2>
                <div class="answer">
                  <hr />
                  <div v-html="Post.Content"></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section
      class="travel-list-box travel-list-2"
      v-if="
        CategoryData.Category != null && CategoryData.Category.Type == 1
          ? true
          : false
      "
    >
      <div class="container">
        <div class="marquee-box" v-if="CategoryData.Marquees != null">
          <div class="img-box"><img src="img/marquee-icon.png" alt="" /></div>
          <marquee behavior="" direction="">
            <p>
              <a
                v-for="Post in CategoryData.Marquees"
                :key="Post.PId"
                href="javascript:void(0);"
                @click="gotoPost(Post)"
                >{{ Post.Title }}</a
              >
            </p>
          </marquee>
        </div>
        <hr v-if="CategoryData.Marquees != null" />
        <div class="title-box box">
          <h1>{{ CategoryData.Category.CategoryName }}</h1>
          <!-- <hr> -->
        </div>
        <div class="box">
          <div class="row">
            <div
              class="col-sm-6 col-lg-4"
              v-for="Post in Posts"
              :key="Post.PId"
            >
              <div class="hot" v-if="Post.IsTop ? true : false">
                <p>HOT</p>
              </div>
              <a href="javascript:void(0);" @click="gotoPost(Post)">
                <div class="img-box">
                  <img
                    :src="CategoryData.SiteUrl + Post.Image"
                    :alt="Post.Title"
                  />
                </div>
                <h2>{{ Post.Title }}</h2>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="page" v-if="pageAll > 1">
        <div class="container">
          <paginate
            :no-li-surround="false"
            :page-count="pageAll"
            :page-range="3"
            :margin-pages="1"
            :click-handler="loadList"
            :prev-text="'<'"
            :next-text="'>'"
            :prev-link-class="'Prev'"
            :next-link-class="'next'"
            :container-class="''"
            :page-link-class="''"
            :active-class="'page-active'"
            :hide-prev-next="false"
          >
          </paginate>
        </div>
      </div>
    </section>
    <section
      class="main"
      v-if="
        CategoryData.Category != null && CategoryData.Category.Type == 4
          ? true
          : false
      "
    >
      <div class="container">
        <div class="row">
          <div
            class="col-6 col-md-3 col-lg-3"
            v-for="Post in Posts"
            :key="Post.PId"
          >
            <div class="box">
              <a href="javascript:void(0);" @click="gotoPost(Post)">
                <div
                  class="img-box"
                  :style="
                    'background: url(' +
                    CategoryData.SiteUrl +
                    Post.Image +
                    ') no-repeat center center; background-size:cover;'
                  "
                >
                  <!-- <img
                    :src="CategoryData.SiteUrl + Post.Image"
                    :alt="Post.Title"
                  /> -->
                </div>
                <p>{{ Post.Title }}</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Paginate from "vuejs-paginate";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.component("paginate", Paginate);
Vue.use(VueI18n);

// this.$t("關閉")
const messages = {
    zh_tw: {
    "關閉": "關閉",
  },
  en: {
    "關閉": "Close",
  },
  jp: {
    "關閉": "閉じる",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "Category",
  i18n,
  data() {
    return {
      CategoryData: {},
      Posts: [],
      pageAll: 0,
      perPage: 10,
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null,
      IsLoaded: false,
      active: 0,
    };
  },
  created: function () {
    Vue.axios
      .get(this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/Category", {
        params: { CId: this.$route.params.CId },
      })
      .then((response) => {
        this.CategoryData = response.data;
        this.active = this.$route.params.CId;
        this.loadList(1);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("travel");
    $(".wrapper").addClass("travel-list");
    $(".wrapper").addClass("member-other");
    if (this.CategoryData.Category.Type == 4) {
      $(".wrapper").addClass("others-list");
    }
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  updated: function () {},
  methods: {
    changeCategory: function (CId) {
      Vue.axios
        .get(
          this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/Category",
          {
            params: { CId: CId },
          }
        )
        .then((response) => {
          this.CategoryData = response.data;
          this.active = CId;
          this.loadList(1);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    gotoTop: function () {
      window.pageYOffset = 0;
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    loadList: function (page) {
      var that = this;
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/PostList",
        type: "post",
        data: {
          CId: that.CategoryData.Category.CId,
          lang: Storage.get("ek_site_lang"),
          page: page,
          perPage: that.perPage,
        },
        dataType: "json",
        error: function () {},
        success: function (res) {
          if (res.status == 1) {
            that.Posts = res.Posts;
            that.perPage = res.perPage;
            that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
            window.pageYOffset = 0;
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          }
        },
      });
    },
    gotoPost(Post) {
      if (Post.Type == 1) {
        if (this.isMobile && typeof cordova != "undefined") {
          cordova.InAppBrowser.open(
            Post.Url,
            "_blank",
            "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
              this.$t("關閉") +
              ",closebuttoncolor=#ffffff"
          );
        } else {
          if (Post.Blank) {
            window.open(Post.Url, "_blank");
          } else {
            window.open(Post.Url);
          }
        }
      } else {
        this.$router.push({
          name: "Post",
          params: { PId: Post.PId },
        });
      }
    },
  },
  updated: function () {
    //$('.item-container').hide();
    // if (!this.IsLoaded) {
    //   $(".item-link:first").click();
    //   $(".marqueePost").marquee({
    //     duration: 10000,
    //     gap: 50,
    //     delayBeforeStart: 0,
    //     direction: "left",
    //     duplicated: false,
    //   });
    //   // 設為已載入
    //   this.IsLoaded = true;
    // }
    // 0617 會員頁裡的其他說明的 QA問題開合
    $(".member-other .qa .box h2").click(function () {
      $(this).parent().siblings().children(".answer").slideUp("slow");
      $(this).siblings(".answer").slideToggle("slow");
    });

    // 0617 會員頁裡的其他說明的 服務說明回到頂端
    $(".member-other .serve .btn-box .btn").click(function () {
      $("html, body").animate({ scrollTop: 0 }, 1000);
    });

    // 0617 會員頁裡的其他說明 頁籤點擊切換內容
    //$(".member-box .btn-box button").eq(0).addClass("active");

    $(".member-other .btn-box button").click(function () {
      // 點任何按鈕 問答合起來
      $(".member-other .qa .box .answer").slideUp("slow");

      var index3 = $(this).index();
      var picWidth3 = $(".main").width();

      $(".member-other .btn-box button").removeClass("active");
      $(this).addClass("active");

      $(".member-other .main-box .main")
        .eq(index3)
        .addClass("show")
        .siblings()
        .removeClass("show");
    });

    // 0621 會員頁裡其他說明的常見問答 頁籤點擊切換內容
    $(".member-other .qa-btn button").eq(0).addClass("qa-active");

    $(".member-other .qa-btn button").click(function () {
      // 點任何按鈕 問答合起來
      $(".member-other .qa .box .answer").slideUp("slow");

      var index4 = $(this).index();
      var picWidth4 = $(".qa").width();

      $(".member-other .qa-btn button").removeClass("qa-active");
      $(this).addClass("qa-active");

      $(".member-other .main-box .main .qa")
        .eq(index4)
        .addClass("show")
        .siblings()
        .removeClass("show");
    });
  },
};

Vue.filter("timeString", function (value, myFormat) {
  return moment(value).format(myFormat || "YYYY-MM-DD, HH:mm:ss");
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Category.vue